export default "__VITE_ASSET__2f128cdd__"